'use strict';

var COOKIE_NAME = 'COOKIE_CONSENT';
function setCookieConsent(value) {
  $.cookie(COOKIE_NAME, value, {
    expires: 365,
    path: '/'
  });
  initCookies();
}
$(function () {
  if ($.cookie(COOKIE_NAME) === undefined) $('.cookies-message').addClass('show');
  $('#accept_cookies, #allow_all_cookies').click(function () {
    $('section#cookies').fadeOut();
    $('#modal_cookies').modal('hide');
    setCookieConsent('11');
  });

  document.querySelectorAll('#reject_cookies').forEach(function (element) {
    element.addEventListener('click', function () {
      document.querySelector('section#cookies').style.display = 'none';
      var modal = new bootstrap.Modal(document.getElementById('modal_cookies'));
      modal.hide();
      setCookieConsent('00');
    });
  });

  $('#cookies_preferences').click(function () {
    var preferences = '';
    preferences = $('#modal_cookies #option1').is(':checked') ? '1' : '0';
    preferences += $('#modal_cookies #option2').is(':checked') ? '1' : '0';
    $('section#cookies').fadeOut();
    $('#modal_cookies').modal('hide');
    setCookieConsent(preferences);
  });
  $('a[data-toogle="self-navigation"]').click(function () {
    $(this).closest('.parent-navigation').addClass('d-none');
    $('#' + $(this).attr('data-target')).removeClass('d-none');
  });
});
//# sourceMappingURL=cookies.js.map

$( document ).ready(function() {
    $('.mainWrapper .t-wrapperHeader .m-search .m-search-button').on('click',function(e){
        $('.m-headerSearchLengDesktop').toggleClass('active');
        e.preventDefault();
    });
    $('#missm-main-navigation button.m-btn-menu').on('click', function(e){
        var liElement = $($(this).closest('li'));
        if (liElement.hasClass('open')) {
            liElement.removeClass('open');
            $(liElement.find('a').first()).attr('aria-expanded', 'false').removeClass('link_active');;
            $(liElement.find('button').first()).attr('aria-expanded', 'false');
        } else {
            liElement.addClass('open');
            liElement.find('a').first().attr('aria-expanded', 'true').addClass('link_active');
            liElement.find('button').first().attr('aria-expanded', 'true');
        }
        e.preventDefault();
    });

    $('.mainWrapper .menu-mobile .accordion .item .item-header .btn-link').on('click', function(e){
        var id = $(this).attr('aria-controls');
        var id_ = id.split('-');
        var id__ = id_[1];
        if($('.mainWrapper .menu-mobile .accordion .item .item-header#item-header-'+id__).hasClass('activo')){
            $('.mainWrapper .menu-mobile .accordion .item .item-header#item-header-'+id__).removeClass('activo');
        } else {
            $('.mainWrapper .menu-mobile .accordion .item .item-header').each(function(){ $(this).removeClass('activo'); });
            $('.mainWrapper .menu-mobile .accordion .item .item-header#item-header-'+id__).addClass('activo');
        }
        e.preventDefault();
    });
    $('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header .btn-link_').on('click', function(e){
        var id = $(this).attr('aria-controls');
        var id_ = id.split('-');
        var id__ = id_[1]+'-'+id_[2];
        if($('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header#item-header-'+id__).hasClass('activo')){
            $('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header#item-header-'+id__).removeClass('activo');
        } else {
            $('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header').each(function(){ $(this).removeClass('activo'); });
            $('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header#item-header-'+id__).addClass('activo');
        }
        e.preventDefault();
    });
    $('.mainWrapper .t-wrapperHeader .m-menuWrapper .m-menuButton').on('click', function(e){
        $('body').addClass('open-menu-mobile');
        e.preventDefault();
    });
    $('.menu-mobile .btn-menu-mobile-close').on('click', function(e){
        $('.mainWrapper .t-wrapperHeader .m-menuWrapper .m-menuButton').trigger('click');
        $('body').removeClass('open-menu-mobile');
        e.preventDefault();
    });
});
/**
 * Corrige los problemas de accesibilidad que Owl Carousel introduce en el DOM:
 *  - Los botones .owl-prev/.owl-next se generan con role="presentation"
 *    (role inapropiado para un <button>) y sin texto perceptible.
 *  - Los slides ocultos quedan con aria-hidden="true" pero conservan en su
 *    interior elementos focusables (enlaces, botones), accesibles por teclado.
 * @param {HTMLElement} carouselEl Elemento .owl-carousel ya construido por Owl.
 */
window.applyOwlA11y = function (carouselEl) {
  var $carousel = $(carouselEl);

  $carousel.find('.owl-nav > .owl-prev, .owl-nav > .owl-next').each(function () {
    var $btn = $(this);
    var isPrev = $btn.hasClass('owl-prev');
    $btn.removeAttr('role').attr('aria-label', isPrev ? 'Anterior' : 'Siguiente');
    // El contenido interno es puramente decorativo
    $btn.children().attr('aria-hidden', 'true');
    // Refleja el estado deshabilitado y sácalo del orden de tabulación
    var disabled = $btn.hasClass('disabled');
    $btn.attr('aria-disabled', disabled ? 'true' : 'false');
    if (disabled) $btn.attr('tabindex', '-1');
    else $btn.removeAttr('tabindex');
  });

  // Evita que el contenido de los slides ocultos sea focusable por teclado,
  // restaurándolo cuando el slide vuelve a ser visible.
  $carousel.find('.owl-item').each(function () {
    var $item = $(this);
    var hidden = $item.attr('aria-hidden') === 'true';
    $item.find('a, button, input, select, textarea, iframe, [tabindex]').each(function () {
      var $f = $(this);
      if (hidden) {
        if ($f.attr('data-owl-tabindex') === undefined) {
          $f.attr('data-owl-tabindex', $f.attr('tabindex') || '');
        }
        $f.attr('tabindex', '-1');
      } else if ($f.attr('data-owl-tabindex') !== undefined) {
        var prev = $f.attr('data-owl-tabindex');
        if (prev === '') $f.removeAttr('tabindex');
        else $f.attr('tabindex', prev);
        $f.removeAttr('data-owl-tabindex');
      }
    });
  });
};

// Engancha la corrección de accesibilidad a todos los carruseles de la página.
// La delegación sobre document captura también el evento "initialized", que Owl
// dispara durante la propia inicialización, sea cual sea la página.
$(document).on(
  'initialized.owl.carousel changed.owl.carousel refreshed.owl.carousel resized.owl.carousel',
  '.owl-carousel',
  function () {
    var el = this;
    // Espera al siguiente tick para actuar tras la reconstrucción interna de Owl
    window.setTimeout(function () {
      window.applyOwlA11y(el);
    }, 0);
  }
);

window.initSyncCarousel = function () {
  var sync1 = $('.owl-sync');
  var sync2 = $('.owl-sync-thumbs');
  var slidesPerPage = 4; //globaly define number of elements per page
  var syncedSecondary = true;
  var synced = false;
  $('.owl-sync')
    .owlCarousel({
      loop: false,
      margin: 10,
      nav: false,
      items: 1,
      autoHeight: true,
      responsive: {
        0: {
          dots: true,
        },
        768: {
          dots: false,
        },
      },
    })
    .on('changed.owl.carousel', syncPosition);

  sync2
    .on('initialized.owl.carousel', function () {
      sync2.find('.owl-item').eq(0).addClass('current');
    })
    .owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: false,
      items: 4,
      navText: [
        '<span class=\'insst-arrow-left-page\'></span>',
        '<span class=\'insst-arrow-right-page\'></span>',
      ],
    })
    .on('changed.owl.carousel', syncPosition2);

  function syncPosition2(el) {
    if (syncedSecondary && !synced) {
      var number = el.item.index;
      sync1.data('owl.carousel').to(number, 100, true);
    }
  }

  sync2.on('click', '.owl-item', function (e) {
    e.preventDefault();
    var number = $(this).index();
    sync1.data('owl.carousel').to(number, 300, true);
  });

  function syncPosition(el) {
    var current = el.item.index;

    sync2.find('.owl-item').removeClass('current').eq(current).addClass('current');
    var onscreen = sync2.find('.owl-item.active').length - 1;
    var start = sync2.find('.owl-item.active').first().index();
    var end = sync2.find('.owl-item.active').last().index();

    synced = true;

    if (current > end) {
      sync2.data('owl.carousel').to(current, 100, true);
    }
    if (current < start) {
      sync2.data('owl.carousel').to(current - onscreen, 100, true);
    }

    synced = false;
  }
};

window.buildMenu = function () {
  if ($('#mp-menu .mp-level > ul > li:not(.invisible)').length) {
    return;
  }

  var ul = $('.mp-menu > .mp-level > ul');
  $('ul#menubar > li').each(function () {
    var li = $('<li></li>').appendTo(ul);
    li.append($(this).find('> a').clone());
    if ($(this).find('> ul').length) {
      var a = $(this).find('> a');
      li.prepend(
        '<a class="mp-next" href="#"><span class="mm-sronly">Open submenu (' +
          a.html() +
          ')</span></a>'
      );
      var mpLevel = $('<div class="mp-level"></div>').appendTo(li);
      mpLevel.append(
        '<div class="mp-navbar"><a class="mp-back" href=""></a>' + a.html() + '</div>'
      );
      var ul2 = $('<ul></ul>').appendTo(mpLevel);

      $(this)
        .find('> ul > li')
        .each(function () {
          var li = $('<li></li>').appendTo(ul2);
          li.append($(this).find('> a').clone());
          li.find('i').remove();
          if ($(this).find('> ul').length) {
            var a = $(this).find('> a');

            li.prepend(
              '<a class="mp-next" href="#"><span class="mm-sronly">Open submenu (' +
                a.html() +
                ')</span></a>'
            );
            li.parent().find('i').remove();
            var mpLevel = $('<div class="mp-level"></div>').appendTo(li);
            mpLevel.append(
              '<div class="mp-navbar"><a class="mp-back" href=""></a>' +
                a.html() +
                '</div>'
            );
            mpLevel.parent().find('i').remove();
            var ul3 = $('<ul></ul>').appendTo(mpLevel);
            $(this)
              .find('> ul > li')
              .each(function () {
                var li = $('<li></li>').appendTo(ul3);
                li.append($(this).find('> a').clone());
              });
          }
        });
    }
  });

  //$('.mp-menu > .mp-level > ul').html(str)
  //new mlPushMenu( document.getElementById( 'mp-menu' ), document.getElementById( 'trigger' ) );
};

$(function () {

  $('.nav-link').on('click', function (event) {
      if ($(window).width() >= 992) { // Solo aplica a pantallas de 992px o más
        var target = $(this).attr('href');
        if (target.startsWith("#")) {
          event.preventDefault();

          $('html, body').animate({
              scrollTop: $(target).offset().top - 100
          }, 500);
        }
      }
  });

  $('section#search_panel i.toggle').click(function () {
    $(this).addClass('d-none');
    $('section#search_panel').addClass('open');
    $('section#search_panel .input-group').removeClass('d-none');
    $('section#search_panel input').focus();
  });
  $('section#search_panel .input-group input').blur(function () {
    setTimeout(function () {
      $('section#search_panel').removeClass('open');
      $('section#search_panel .input-group').addClass('d-none');
      $('section#search_panel i.toggle').removeClass('d-none');
    }, 500);
  });

  var is_mobile = window.innerWidth < 992;
  if (is_mobile) buildMenu();
  else {
    function checkIsMobile() {
      if (window.innerWidth < 992) {
        buildMenu();
      } else {
        setTimeout(checkIsMobile, 200);
      }
    }

    setTimeout(checkIsMobile, 200);
  }

  $('.owl-insst').owlCarousel({
    loop: false,
    margin: 10,
    autoHeight: true,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 3,
      },
    },
    navText: [
      '<span class=\'insst-arrow-left-page\'></span>',
      '<span class=\'insst-arrow-right-page\'></span>',
    ],
  });
  $('.owl-logos').owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
    },
    navText: [
      '<span class=\'insst-arrow-left-page\'></span>',
      '<span class=\'insst-arrow-right-page\'></span>',
    ],
  });

  $('.owl-images').owlCarousel({
    loop: false,
    margin: 10,
    nav: true,

    responsive: {
      0: {
        items: 1,
        dots: true,
      },
      768: {
        items: 4,
        dots: false,
      },
    },
    navText: [
      '<span class=\'insst-arrow-left-page\'></span>',
      '<span class=\'insst-arrow-right-page\'></span>',
    ],
  });

  $('.owl-silent').owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    responsive: {
      0: {
        items: 1,
        dots: true,
      },
      768: {
        items: 3,
        dots: false,
      },
    },
  });

  initSyncCarousel();

  $('figure.swap-hover').hover(
    function () {
      $(this).find('img.img-hover').show();
      $(this).find('img:not(.img-hover)').hide();
    },
    function () {
      $(this).find('img.img-hover').hide();
      $(this).find('img:not(.img-hover)').show();
    }
  );

  var goTop = $('#go_top');
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 200) {
      goTop.fadeIn();
    } else {
      goTop.fadeOut();
    }
  });

  goTop.click(function () {
    $('html, body').stop().animate(
      {
        scrollTop: 0,
      },
      500
    );
  });

  var equalizeCards = function (classBannerHome) {
    $(classBannerHome).each(function () {
      var cards = $(this).find('.card');

      cards.css('height', 'auto');
      var heights = $.map(cards, function (element) {
        return $(element).outerHeight();
      });

      var height = Math.max.apply(null, heights);

      cards.css('height', height);
    });
  };

  var resizeSensorCardHome = function (classBannerHome) {
    new ResizeSensor($(classBannerHome).find('.card')[0], function () {
      $(classBannerHome).find('.card').css('overflow', 'hidden');
      $($(classBannerHome).find('.card')[2]).css('overflow', 'auto');
      equalizeCards(classBannerHome);
    });
  };
  var resizeSensor = function (classParent, classItem) {
    new ResizeSensor($(classParent).find(classItem)[0], function () {
      var itemsTotal = $(classParent).find(classItem);

      for (var i = 0; i < itemsTotal.length; i += 4) {
        var items = itemsTotal.slice(i, i + 4);
        items.css('height', 'auto');
        var heights = $.map(items, function (element) {
          return $(element).outerHeight();
        });

        var height = Math.max.apply(null, heights);

        items.css('height', height).css('overflow', 'auto');
      }
    });
  };

  if ($('.banner-home').length) {
    resizeSensorCardHome('.banner-home');
  }
  if ($('.banner-subhome.normative').length) {
    resizeSensorCardHome('.banner-subhome.normative');
  }
  if ($('.cards').length) {
    resizeSensorCardHome('.cards');
    if ($('a[data-toggle="tab"]').length) {
      $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        equalizeCards('.tab-content .cards');
      });
    }
  }

  if ($('.grid-list').length) {
    resizeSensor('.grid-list', 'article', 4);
  }

  if ($('.double-info').length) {
    new ResizeSensor($('.double-info').find('.info')[1], function () {
      //setTimeout(function(){
      var infos = $('.double-info').find('.info');

      var height = $(infos[1]).outerHeight();
      $('.double-info').find('picture').css('height', height).css('overflow', 'visible');
      //}, 500)
    });
  }

  $('section.areas .tab-pane').on('show.bs.collapse', function () {
    var current = $(this);
    $('section.areas .tab-pane').each(function () {
      if ($(this) != current) {
        $(this).collapse('hide');
      }
    });
  });
  if (!is_mobile) $('section.areas .tab-pane.active').addClass('show');

  $('section.filter header').click(function () {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).parent().find('.dropdown-menu').removeClass('show');
    } else {
      var is_mobile = window.innerWidth < 992;
      if (is_mobile) {
        $(this).addClass('open');
        $(this).parent().find('.dropdown-menu').addClass('show');
      }
    }
  });

  if ($('section.tree').length) {
    var toggler = document.getElementsByClassName('branch');
    var i;

    for (i = 0; i < toggler.length; i++) {
      toggler[i].addEventListener('click', function () {
        this.parentElement.querySelector('.nested').classList.toggle('active');
        this.classList.toggle('branch-down');
      });
    }
  }
  var url = document.location.toString();
  if (url.match('#')) {
    var tab = $('.nav-tabs a[href="#' + url.split('#')[1] + '"]');
    if (tab.length) {
      tab.tab('show');
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: tab.offset().top,
        },
        100
      );
    }
  }

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    var elem_id = $(e.currentTarget).attr('href');
    if (!$(elem_id).hasClass('loaded')) {
      $(elem_id).addClass('overlay');
      setTimeout(function () {
        $(elem_id).addClass('loaded').removeClass('overlay');
      }, 800);
    }
  });

  $('select.like-placeholder').change(function () {
    if (this.value == '') $(this).css('color', '#6c757d');
    else $(this).css('color', '#555');
  });
  $('select.like-placeholder').css('color', '#6c757d');

  $('.owl-onpage').owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      600: {
        items: 3,
        nav: false,
      },
      1000: {
        items: 5,
        nav: true,
        loop: false,
      },
    },
    navText: [
      '<span class=\'insst-arrow-left-page\'></span>',
      '<span class=\'insst-arrow-right-page\'></span>',
    ],
  });
  $('.owl-onpage .item a').on('click', function () {
    var theSrc = $(this).find('img').attr('src');
    var alt = $(this).find('img').attr('alt');
    var owlModal = $('#owl-modal');
    owlModal.empty();
    var item = $('<div>', { class: 'item' }).appendTo(owlModal);
    $('<img>', { src: theSrc, alt: alt }).appendTo(item);
    $('<span>' + alt + '</span>').appendTo(item);
    $('.item span').css('color', 'white');
    $(GListModalGallery).modal('show');
  });
});

function setParam(key, value) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set(key, value);
  window.location.search = urlParams;
}

function facetRedirect(categoryName, category) {
  if (category === '0') {
    facetCleanRedirect(categoryName);
    return;
  }

  const parser = new URL(window.location);
  parser.searchParams.set(categoryName, category);
  parser.searchParams.delete('start');
  parser.searchParams.delete('delta');
  window.location = parser.href;
}
function facetCleanRedirect(categoryName) {
  const parser = new URL(window.location);
  parser.searchParams.delete(categoryName);
  parser.searchParams.delete('start');
  parser.searchParams.delete('delta');
  window.location = parser.href;
}

/* ACORDEON FICHA */

let accordions = document.querySelectorAll('.accordion h2');
function adjustAccordionHeight() {
  for (let accordion of accordions) {
    const panel = accordion.nextElementSibling;

    if (accordion.classList.contains('active')) {
      panel.style.maxHeight = 'none';
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }
}

function openAllAccordions() {
  for (let accordion of accordions) {
    const panel = accordion.nextElementSibling;
    const button = accordion.querySelector('button');

    accordion.classList.add('active');
    panel.style.maxHeight = 'none';
    panel.style.maxHeight = panel.scrollHeight + 'px';
    button.setAttribute('aria-expanded', 'true');
  }
}

function closeAllAccordions() {
  for (let accordion of accordions) {
    const panel = accordion.nextElementSibling;
    const button = accordion.querySelector('button');

    accordion.classList.remove('active');
    panel.style.maxHeight = null;
    button.setAttribute('aria-expanded', 'false');
  }
}

for (let i = 0; i < accordions.length; i++) {
  accordions[i].addEventListener('click', function () {
    const button = this.querySelector('button');
    const panel = this.nextElementSibling;

    if (this.classList.contains('active')) {
      panel.style.maxHeight = null;
      button.setAttribute('aria-expanded', 'false');
    } else {
      setTimeout(() => {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        button.setAttribute('aria-expanded', 'true');
      }, 500);
    }
    this.classList.toggle('active');
  });
}

document.addEventListener('DOMContentLoaded', adjustAccordionHeight);
window.addEventListener('resize', adjustAccordionHeight);

window.addEventListener('beforeprint', openAllAccordions);
window.addEventListener('afterprint', closeAllAccordions);

// VIRTUAL-HREF

document.addEventListener('DOMContentLoaded', function () {
  var virtualHrefs = document.querySelectorAll('.virtual-href, .override-virtual-href');

  function handleVirtualHrefClick(e) {
    e.preventDefault();
    e.stopPropagation();


    var href = e.currentTarget.getAttribute('href');
    var target = e.currentTarget.getAttribute('target');

    if (href) {
      if (target === '_blank') {
        window.open(href, '_blank');
      } else {
        window.location.href = href;
      }
    } else {
      var mainHref = e.currentTarget.querySelector('.main-href');
      if (mainHref) {
        if (mainHref.getAttribute('target') === '_blank') {
          window.open(mainHref.getAttribute('href'), '_blank');
        } else {
          window.location.href = mainHref.getAttribute('href');
        }
      }
    }
  }

  virtualHrefs.forEach(function (virtualHref) {
    virtualHref.addEventListener('click', handleVirtualHrefClick);
  });
});

// BUSCAR

document.addEventListener('DOMContentLoaded', function () {
  var searchBtn = document.querySelector('.m-search');

  searchBtn.addEventListener('click', function () {
    this.classList.add('active');
  });
});

/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/

window.overlayHover = false;



var Menubar = function (domNode) {
  var elementChildren,
    msgPrefix = 'Menubar constructor argument menubarNode ';

  // Check whether menubarNode is a DOM element
  if (!(domNode instanceof Element)) {
    throw new TypeError(msgPrefix + 'is not a DOM Element.');
  }

  // Check whether menubarNode has descendant elements
  if (domNode.childElementCount === 0) {
    throw new Error(msgPrefix + 'has no element children.');
  }

  // Check whether menubarNode has A elements
  e = domNode.firstElementChild;
  while (e) {
    var menubarItem = e.firstElementChild;
    if (e && menubarItem && menubarItem.tagName !== 'A') {
      throw new Error(msgPrefix + 'has child elements are not A elements.');
    }
    e = e.nextElementSibling;
  }

  this.isMenubar = true;

  this.domNode = domNode;

  this.menubarItems = []; // See Menubar init method
  this.firstChars = []; // See Menubar init method

  this.firstItem = null; // See Menubar init method
  this.lastItem = null; // See Menubar init method

  this.hasFocus = false; // See MenubarItem handleFocus, handleBlur
  this.hasHover = false; // See Menubar handleMouseover, handleMouseout
};

/*
*   @method Menubar.prototype.init
*
*   @desc
*       Adds ARIA role to the menubar node
*       Traverse menubar children for A elements to configure each A element as a ARIA menuitem
*       and populate menuitems array. Initialize firstItem and lastItem properties.
*/
Menubar.prototype.init = function () {
  var menubarItem, childElement, menuElement, textContent, numItems;


  // Traverse the element children of menubarNode: configure each with
  // menuitem role behavior and store reference in menuitems array.
  elem = this.domNode.firstElementChild;

  while (elem) {
    menuElement = elem.firstElementChild;

    if (elem && menuElement && menuElement.tagName === 'A') {
      menubarItem = new MenubarItem(menuElement, this);
      menubarItem.init();
      this.menubarItems.push(menubarItem);
      textContent = menuElement.textContent.trim();
      this.firstChars.push(textContent.substring(0, 1).toLowerCase());
    }

    elem = elem.nextElementSibling;
  }

  // Use populated menuitems array to initialize firstItem and lastItem.
  numItems = this.menubarItems.length;
  if (numItems > 0) {
    this.firstItem = this.menubarItems[ 0 ];
    this.lastItem = this.menubarItems[ numItems - 1 ];
  }
  this.firstItem.domNode.tabIndex = 0;
};

/* FOCUS MANAGEMENT METHODS */

Menubar.prototype.setFocusToItem = function (newItem) {

  var flag = false;

  for (var i = 0; i < this.menubarItems.length; i++) {
    var mbi = this.menubarItems[i];

    if (mbi.domNode.tabIndex == 0) {
      flag = mbi.domNode.getAttribute('aria-expanded') === 'true';
    }

    mbi.domNode.tabIndex = -1;
    if (mbi.popupMenu) {
      mbi.popupMenu.close();
    }
  }

  newItem.domNode.focus();
  newItem.domNode.tabIndex = 0;

  if (flag && newItem.popupMenu) {
    newItem.popupMenu.open();
  }
};

Menubar.prototype.setFocusToFirstItem = function (flag) {
  this.setFocusToItem(this.firstItem);
};

Menubar.prototype.setFocusToLastItem = function (flag) {
  this.setFocusToItem(this.lastItem);
};

Menubar.prototype.setFocusToPreviousItem = function (currentItem) {
  var index;

  if (currentItem === this.firstItem) {
    newItem = this.lastItem;
  }
  else {
    index = this.menubarItems.indexOf(currentItem);
    newItem = this.menubarItems[ index - 1 ];
  }

  this.setFocusToItem(newItem);

};

Menubar.prototype.setFocusToNextItem = function (currentItem) {
  var index;

  if (currentItem === this.lastItem) {
    newItem = this.firstItem;
  }
  else {
    index = this.menubarItems.indexOf(currentItem);
    newItem = this.menubarItems[ index + 1 ];
  }

  this.setFocusToItem(newItem);

};

Menubar.prototype.setFocusByFirstCharacter = function (currentItem, char) {
  var start, index;
  var flag = currentItem.domNode.getAttribute('aria-expanded') === 'true';

  char = char.toLowerCase();

  // Get start index for search based on position of currentItem
  start = this.menubarItems.indexOf(currentItem) + 1;
  if (start === this.menubarItems.length) {
    start = 0;
  }

  // Check remaining slots in the menu
  index = this.getIndexFirstChars(start, char);

  // If not found in remaining slots, check from beginning
  if (index === -1) {
    index = this.getIndexFirstChars(0, char);
  }

  // If match was found...
  if (index > -1) {
    this.setFocusToItem(this.menubarItems[ index ]);
  }
};

Menubar.prototype.getIndexFirstChars = function (startIndex, char) {
  for (var i = startIndex; i < this.firstChars.length; i++) {
    if (char === this.firstChars[ i ]) {
      return i;
    }
  }
  return -1;
};
/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/
var MenubarItem = function (domNode, menuObj) {

  this.menu = menuObj;
  this.domNode = domNode;
  this.popupMenu = false;

  this.hasFocus = false;
  this.hasHover = false;

  this.isMenubarItem = true;

  this.keyCode = Object.freeze({
    'TAB': 9,
    'RETURN': 13,
    'ESC': 27,
    'SPACE': 32,
    'PAGEUP': 33,
    'PAGEDOWN': 34,
    'END': 35,
    'HOME': 36,
    'LEFT': 37,
    'UP': 38,
    'RIGHT': 39,
    'DOWN': 40
  });
};

MenubarItem.prototype.init = function () {
  this.domNode.tabIndex = -1;

  this.domNode.addEventListener('keydown', this.handleKeydown.bind(this));
  this.domNode.addEventListener('click', this.handleClick.bind(this));
  this.domNode.addEventListener('focus', this.handleFocus.bind(this));
  this.domNode.addEventListener('blur', this.handleBlur.bind(this));
  this.domNode.addEventListener('mouseover', this.handleMouseover.bind(this));
  this.domNode.addEventListener('mouseout', this.handleMouseout.bind(this));

  // Initialize pop up menus

  var nextElement = this.domNode.nextElementSibling;

  if (nextElement && nextElement.tagName === 'UL') {
    this.popupMenu = new PopupMenu(nextElement, this);
    this.popupMenu.init();
  }

};

MenubarItem.prototype.handleKeydown = function (event) {
  var tgt = event.currentTarget,
    char = event.key,
    flag = false,
    clickEvent;

  function isPrintableCharacter (str) {
    return str.length === 1 && str.match(/\S/);
  }

  switch (event.keyCode) {
    case this.keyCode.SPACE:
    case this.keyCode.RETURN:
    case this.keyCode.DOWN:
      if (this.popupMenu) {
        this.popupMenu.open();
        this.popupMenu.setFocusToFirstItem();
        flag = true;
      }
      break;

    case this.keyCode.LEFT:
      this.menu.setFocusToPreviousItem(this);
      flag = true;
      break;

    case this.keyCode.RIGHT:
      this.menu.setFocusToNextItem(this);
      flag = true;
      break;

    case this.keyCode.UP:
      if (this.popupMenu) {
        this.popupMenu.open();
        this.popupMenu.setFocusToLastItem();
        flag = true;
      }
      break;

    case this.keyCode.HOME:
    case this.keyCode.PAGEUP:
      this.menu.setFocusToFirstItem();
      flag = true;
      break;

    case this.keyCode.END:
    case this.keyCode.PAGEDOWN:
      this.menu.setFocusToLastItem();
      flag = true;
      break;

    case this.keyCode.TAB:
      this.popupMenu.close(true);
      break;

    case this.keyCode.ESC:
      this.popupMenu.close(true);
      break;

    default:
      if (isPrintableCharacter(char)) {
        this.menu.setFocusByFirstCharacter(this, char);
        flag = true;
      }
      break;
  }

  if (flag) {
    event.stopPropagation();
    event.preventDefault();
  }
};

MenubarItem.prototype.handleClick = function (event) {
  if (this.popupMenu) {
    // for menuitem with menu, prevent default anchor behavior on click
    // (which jumps to top of page for href="#" in some browsers)
    if (this.domNode.getAttribute('href').length < 2)
      event.preventDefault();
  }
};

MenubarItem.prototype.setExpanded = function (value) {
  var menus = $('#menubar ul[role="menu"]:visible');
  if (menus.length){
    menus.each(function(){
      $('#overlay-menu').css('height', $(this).outerHeight() + 'px')  
    })
  }else{
    $('#overlay-menu').css('height',  '0px')
  }
  if (value) {
    this.domNode.setAttribute('aria-expanded', 'true');
  }
  else {
    this.domNode.setAttribute('aria-expanded', 'false');
  }
};

MenubarItem.prototype.handleFocus = function (event) {
  this.menu.hasFocus = true;
};

MenubarItem.prototype.handleBlur = function (event) {
  this.menu.hasFocus = false;
};

MenubarItem.prototype.handleMouseover = function (event) {
  this.hasHover = true;
  for (var i = 0; i < this.menu.menubarItems.length; i++) {
    var mbi = this.menu.menubarItems[i];

    if (mbi.popupMenu) {
      mbi.popupMenu.close(true);
    }
  }
  if (this.popupMenu)
    this.popupMenu.open();
};

MenubarItem.prototype.handleMouseout = function (event) {
  this.hasHover = false;
  if (this.popupMenu)
    setTimeout(this.popupMenu.close.bind(this.popupMenu, false), 300);
};

/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/
var PopupMenu = function (domNode, controllerObj) {
  var elementChildren,
    msgPrefix = 'PopupMenu constructor argument domNode ';

  // Check whether domNode is a DOM element
  if (!(domNode instanceof Element)) {
    throw new TypeError(msgPrefix + 'is not a DOM Element.');
  }
  // Check whether domNode has child elements
  if (domNode.childElementCount === 0) {
    throw new Error(msgPrefix + 'has no element children.');
  }
  // Check whether domNode descendant elements have A elements
  var childElement = domNode.firstElementChild;
  while (childElement) {
    var menuitem = childElement.firstElementChild;
    if (menuitem && menuitem === 'A') {
      throw new Error(msgPrefix + 'has descendant elements that are not A elements.');
    }
    childElement = childElement.nextElementSibling;
  }

  this.isMenubar = false;

  this.domNode    = domNode;
  this.controller = controllerObj;

  this.menuitems = []; // See PopupMenu init method
  this.firstChars = []; // See PopupMenu init method

  this.firstItem = null; // See PopupMenu init method
  this.lastItem = null; // See PopupMenu init method

  this.hasFocus = false; // See MenuItem handleFocus, handleBlur
  this.hasHover = false; // See PopupMenu handleMouseover, handleMouseout
};

/*
*   @method PopupMenu.prototype.init
*
*   @desc
*       Add domNode event listeners for mouseover and mouseout. Traverse
*       domNode children to configure each menuitem and populate menuitems
*       array. Initialize firstItem and lastItem properties.
*/
PopupMenu.prototype.init = function () {
  var childElement, menuElement, menuItem, textContent, numItems, label;

  // Configure the domNode itself

  this.domNode.addEventListener('mouseover', this.handleMouseover.bind(this));
  this.domNode.addEventListener('mouseout', this.handleMouseout.bind(this));

  // Traverse the element children of domNode: configure each with
  // menuitem role behavior and store reference in menuitems array.
  childElement = this.domNode.firstElementChild;

  while (childElement) {
    menuElement = childElement.firstElementChild;

    if (menuElement && menuElement.tagName === 'A') {
      menuItem = new MenuItem(menuElement, this);
      menuItem.init();
      this.menuitems.push(menuItem);
      textContent = menuElement.textContent.trim();
      this.firstChars.push(textContent.substring(0, 1).toLowerCase());
    }
    childElement = childElement.nextElementSibling;
  }

  // Use populated menuitems array to initialize firstItem and lastItem.
  numItems = this.menuitems.length;
  if (numItems > 0) {
    this.firstItem = this.menuitems[ 0 ];
    this.lastItem = this.menuitems[ numItems - 1 ];
  }
};

/* EVENT HANDLERS */

PopupMenu.prototype.handleMouseover = function (event) {
  this.hasHover = true;
};

PopupMenu.prototype.handleMouseout = function (event) {
  this.hasHover = false;
  setTimeout(this.close.bind(this, false), 1);
};

/* FOCUS MANAGEMENT METHODS */

PopupMenu.prototype.setFocusToController = function (command, flag) {

  if (typeof command !== 'string') {
    command = '';
  }

  function setFocusToMenubarItem (controller, close) {
    while (controller) {
      if (controller.isMenubarItem) {
        controller.domNode.focus();
        return controller;
      }
      else {
        if (close) {
          controller.menu.close(true);
        }
        controller.hasFocus = false;
      }
      controller = controller.menu.controller;
    }
    return false;
  }

  if (command === '') {
    if (this.controller && this.controller.domNode) {
      this.controller.domNode.focus();
    }
    return;
  }

  if (!this.controller.isMenubarItem) {
    this.controller.domNode.focus();
    this.close();

    if (command === 'next') {
      var menubarItem = setFocusToMenubarItem(this.controller, false);
      if (menubarItem) {
        menubarItem.menu.setFocusToNextItem(menubarItem, flag);
      }
    }
  }
  else {
    if (command === 'previous') {
      this.controller.menu.setFocusToPreviousItem(this.controller, flag);
    }
    else if (command === 'next') {
      this.controller.menu.setFocusToNextItem(this.controller, flag);
    }
  }

};

PopupMenu.prototype.setFocusToFirstItem = function () {
  this.firstItem.domNode.focus();
};

PopupMenu.prototype.setFocusToLastItem = function () {
  this.lastItem.domNode.focus();
};

PopupMenu.prototype.setFocusToPreviousItem = function (currentItem) {
  var index;

  if (currentItem === this.firstItem) {
    this.lastItem.domNode.focus();
  }
  else {
    index = this.menuitems.indexOf(currentItem);
    this.menuitems[ index - 1 ].domNode.focus();
  }
};

PopupMenu.prototype.setFocusToNextItem = function (currentItem) {
  var index;

  if (currentItem === this.lastItem) {
    this.firstItem.domNode.focus();
  }
  else {
    index = this.menuitems.indexOf(currentItem);
    this.menuitems[ index + 1 ].domNode.focus();
  }
};

PopupMenu.prototype.setFocusByFirstCharacter = function (currentItem, char) {
  var start, index;

  char = char.toLowerCase();

  // Get start index for search based on position of currentItem
  start = this.menuitems.indexOf(currentItem) + 1;
  if (start === this.menuitems.length) {
    start = 0;
  }

  // Check remaining slots in the menu
  index = this.getIndexFirstChars(start, char);

  // If not found in remaining slots, check from beginning
  if (index === -1) {
    index = this.getIndexFirstChars(0, char);
  }

  // If match was found...
  if (index > -1) {
    this.menuitems[ index ].domNode.focus();
  }
};

PopupMenu.prototype.getIndexFirstChars = function (startIndex, char) {
  for (var i = startIndex; i < this.firstChars.length; i++) {
    if (char === this.firstChars[ i ]) {
      return i;
    }
  }
  return -1;
};

/* MENU DISPLAY METHODS */

PopupMenu.prototype.open = function () {
  // Get position and bounding rectangle of controller object's DOM node
  var rect = this.controller.domNode.getBoundingClientRect();

  for (var i = 0; i < this.menuitems.length; i++) {
    var mi = this.menuitems[i];
    if (mi.popupMenu) {
      mi.popupMenu.close(true);
    }
  }

  // Set CSS properties
  if (!this.controller.isMenubarItem) {
    this.domNode.parentNode.style.position = 'relative';
    this.domNode.style.display = 'block';
    this.domNode.style.position = 'absolute';
    this.domNode.style.left = rect.width + '0px';
    this.domNode.style.zIndex = 100;
    if ($(this.domNode).outerHeight() > $(this.domNode.parentNode.parentNode).outerHeight()){
      this.domNode.parentNode.parentNode.style.height = $(this.domNode).outerHeight() + 'px';
    }

  }
  else {
    this.domNode.style.display = 'block';
    this.domNode.style.position = 'absolute';
    this.domNode.style.top = (rect.height - 1) + 'px';
    this.domNode.style.zIndex = 100;
  }

  this.controller.setExpanded(true);

};

PopupMenu.prototype.close = function (force) {

  var controllerHasHover = this.controller.hasHover;

  var hasFocus = this.hasFocus;

  for (var i = 0; i < this.menuitems.length; i++) {
    var mi = this.menuitems[i];
    if (mi.popupMenu) {
      hasFocus = hasFocus | mi.popupMenu.hasFocus;
    }
  }

  if (!this.controller.isMenubarItem) {
    controllerHasHover = false;
  }

  if (force || (!window.overlayHover && !hasFocus && !this.hasHover && !controllerHasHover)) {
    this.domNode.style.display = 'none';
    this.domNode.style.zIndex = 0;
    this.controller.setExpanded(false);
    if (!this.controller.isMenubarItem) {
      this.domNode.parentNode.parentNode.style.height = 'auto';
    }
  }
};

/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/
var MenuItem = function (domNode, menuObj) {

  if (typeof popupObj !== 'object') {
    popupObj = false;
  }

  this.domNode = domNode;
  this.menu = menuObj;
  this.popupMenu = false;
  this.isMenubarItem = false;

  this.keyCode = Object.freeze({
    'TAB': 9,
    'RETURN': 13,
    'ESC': 27,
    'SPACE': 32,
    'PAGEUP': 33,
    'PAGEDOWN': 34,
    'END': 35,
    'HOME': 36,
    'LEFT': 37,
    'UP': 38,
    'RIGHT': 39,
    'DOWN': 40
  });
};

MenuItem.prototype.init = function () {
  this.domNode.tabIndex = -1;

  this.domNode.addEventListener('keydown', this.handleKeydown.bind(this));
  this.domNode.addEventListener('click', this.handleClick.bind(this));
  this.domNode.addEventListener('focus', this.handleFocus.bind(this));
  this.domNode.addEventListener('blur', this.handleBlur.bind(this));
  this.domNode.addEventListener('mouseover', this.handleMouseover.bind(this));
  this.domNode.addEventListener('mouseout', this.handleMouseout.bind(this));

  // Initialize flyout menu

  var nextElement = this.domNode.nextElementSibling;

  if (nextElement && nextElement.tagName === 'UL') {
    this.popupMenu = new PopupMenu(nextElement, this);
    this.popupMenu.init();
  }

};

MenuItem.prototype.isExpanded = function () {
  return this.domNode.getAttribute('aria-expanded') === 'true';
};

/* EVENT HANDLERS */

MenuItem.prototype.handleKeydown = function (event) {
  var tgt  = event.currentTarget,
    char = event.key,
    flag = false,
    clickEvent;

  function isPrintableCharacter (str) {
    return str.length === 1 && str.match(/\S/);
  }

  switch (event.keyCode) {
    case this.keyCode.SPACE:
    case this.keyCode.RETURN:
      if (this.popupMenu) {
        this.popupMenu.open();
        this.popupMenu.setFocusToFirstItem();
      }
      else {

        // Create simulated mouse event to mimic the behavior of ATs
        // and let the event handler handleClick do the housekeeping.
        try {
          clickEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
          });
        }
        catch (err) {
          if (document.createEvent) {
            // DOM Level 3 for IE 9+
            clickEvent = document.createEvent('MouseEvents');
            clickEvent.initEvent('click', true, true);
          }
        }
        tgt.dispatchEvent(clickEvent);
      }

      flag = true;
      break;

    case this.keyCode.UP:
      this.menu.setFocusToPreviousItem(this);
      flag = true;
      break;

    case this.keyCode.DOWN:
      this.menu.setFocusToNextItem(this);
      flag = true;
      break;

    case this.keyCode.LEFT:
      this.menu.setFocusToController('previous', true);
      this.menu.close(true);
      flag = true;
      break;

    case this.keyCode.RIGHT:
      if (this.popupMenu) {
        this.popupMenu.open();
        this.popupMenu.setFocusToFirstItem();
      }
      else {
        this.menu.setFocusToController('next', true);
        this.menu.close(true);
      }
      flag = true;
      break;

    case this.keyCode.HOME:
    case this.keyCode.PAGEUP:
      this.menu.setFocusToFirstItem();
      flag = true;
      break;

    case this.keyCode.END:
    case this.keyCode.PAGEDOWN:
      this.menu.setFocusToLastItem();
      flag = true;
      break;

    case this.keyCode.ESC:
      this.menu.setFocusToController();
      this.menu.close(true);
      flag = true;
      break;

    case this.keyCode.TAB:
      this.menu.setFocusToController();
      break;

    default:
      if (isPrintableCharacter(char)) {
        this.menu.setFocusByFirstCharacter(this, char);
        flag = true;
      }
      break;
  }

  if (flag) {
    event.stopPropagation();
    event.preventDefault();
  }
};

MenuItem.prototype.setExpanded = function (value) {
  var menus = $('ul[role="menu"]:visible');

  if (menus.length){
    var max = 0
    menus.each(function(){
      if ($(this).outerHeight() > max)
        max = $(this).outerHeight()
    })
    $('#overlay-menu').css('height', max + 'px')  
  }else{
    $('#overlay-menu').css('height',  '0px')
  }
  if (value) {
    this.domNode.setAttribute('aria-expanded', 'true');
  }
  else {
    this.domNode.setAttribute('aria-expanded', 'false');
  }
};

MenuItem.prototype.handleClick = function (event) {
  this.menu.setFocusToController();
  this.menu.close(true);
  if (this.popupMenu) {
    // for menuitem with menu, prevent default anchor behavior on click
    // (which jumps to top of page for href="#" in some browsers)
    if (this.domNode.getAttribute('href').length < 2)
      event.preventDefault();
  }
};

MenuItem.prototype.handleFocus = function (event) {
  this.menu.hasFocus = true;
};

MenuItem.prototype.handleBlur = function (event) {
  this.menu.hasFocus = false;
  setTimeout(this.menu.close.bind(this.menu, false), 300);
};

MenuItem.prototype.handleMouseover = function (event) {
  this.menu.hasHover = true;
  this.menu.open();
  for (var i = 0; i < this.menu.menuitems.length; i++) {
    var mbi = this.menu.menuitems[i];
    mbi.domNode.tabIndex = -1;
    if (mbi.popupMenu) {
      mbi.popupMenu.close(true);
    }
  }

  if (this.popupMenu) {
    this.popupMenu.hasHover = true;
    this.popupMenu.open();
  }
};

MenuItem.prototype.handleMouseout = function (event) {
  var popupmenu = false;
  if (this.popupMenu && $(this.domNode).closest('ul').attr('role') != 'menu') {
    this.popupMenu.hasHover = false;
    this.popupMenu.close(true);  
  }

  this.menu.hasHover = false;
  var menu = this.menu;
  
  setTimeout(function(){
    menu.close.bind(menu, false)
  }, 300);
};

$(function(){
  
  if($('#menubar').length){
    var menubar = new Menubar(document.getElementById('menubar'));
    menubar.init();

    $('#overlay-menu, ul[role="menu"], ul[role="menu"] > li').mouseover(function(){
      window.overlayHover = true;
    })

    $('#overlay-menu, ul[role="menu"], ul[role="menu"] > li').mouseout(function(e){
      if(e.relatedTarget){

        var role = e.relatedTarget.getAttribute('role');
        if (role=='menuitem' ||role=='menu' || role =='none')
          return;
        var _id = e.relatedTarget.getAttribute('id');
        if (_id=='overlay-menu')
          return;
      }

      window.overlayHover = false;

      for (var i = 0; i < menubar.menubarItems.length; i++) {
        var mbi = menubar.menubarItems[i];

        if (mbi.domNode.tabIndex == 0) {
          flag = mbi.domNode.getAttribute('aria-expanded') === 'true';
        }

        mbi.domNode.tabIndex = -1;
        if (mbi.popupMenu) {
          mbi.popupMenu.close();
        }
      }
    });
  }
});
// Scripts para el componente formacion-detalles

document.addEventListener("DOMContentLoaded", function () {
    const togglePassword = document.getElementById("toggleLoginPassword");
    const passwordInput = document.getElementById("loginPassword");

    if (togglePassword) {
        togglePassword.addEventListener("click", function () {
            const type =
                passwordInput.getAttribute("type") === "password" ? "text" : "password";
            passwordInput.setAttribute("type", type);
            this.classList.toggle("showing");
        });
    }
});

// Scripts para el componente home-main

document.addEventListener("DOMContentLoaded", function () {
  const togglePassword = document.getElementById("togglePassword");
  const passwordInput = document.getElementById("password");

  if (togglePassword) {
    togglePassword.addEventListener("click", function () {
      const type =
          passwordInput.getAttribute("type") === "password" ? "text" : "password";
      passwordInput.setAttribute("type", type);
      this.classList.toggle("showing");
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.home-materiales-tabs [role="tab"]');
  const tabPanels = document.querySelectorAll('.home-materiales-tabs [role="tabpanel"]');

  tabs.forEach((tab) => {
    tab.addEventListener("click", changeTabs);
  });

  function changeTabs(e) {
    const target = e.target;
    const panel = document.getElementById(target.getAttribute("aria-controls"));

    tabs.forEach((t) => {
      t.setAttribute("aria-selected", "false");
      t.setAttribute("tabindex", "-1");
    });

    tabPanels.forEach((p) => {
      p.hidden = true;
    });

    target.setAttribute("aria-selected", "true");
    target.setAttribute("tabindex", "0");
    panel.hidden = false;
  }
});

// Scripts para el componente home-noticias

var carousels = document.getElementsByClassName("carousel");
if (carousels.length > 0) {

  carousels = Array.from(carousels);

    carousels.forEach(function(carousel) {
        var pictures = carousel.querySelectorAll('picture');
        pictures.forEach(function(picture) {
          var imgElement = picture.querySelector('img'); // Cambiando de 'img.lazyload' a 'img'
          if (imgElement && imgElement.src) {  // Cambiando de 'getAttribute('data-src')' a '.src'
              var imgUrl = imgElement.src;
              picture.style.setProperty('--image-url', `url(${imgUrl})`);
          }
      });
    });

  /* focusin/out event polyfill (firefox) */
  (function () {
    var w = window,
      d = w.document;

    if (w.onfocusin === undefined) {
      d.addEventListener("focus", addPolyfill, true);
      d.addEventListener("blur", addPolyfill, true);
      d.addEventListener("focusin", removePolyfill, true);
      d.addEventListener("focusout", removePolyfill, true);
    }
    function addPolyfill(e) {
      var type = e.type === "focus" ? "focusin" : "focusout";
      var event = new CustomEvent(type, { bubbles: true, cancelable: false });
      event.c1Generated = true;
      e.target.dispatchEvent(event);
    }
    function removePolyfill(e) {
      if (!e.c1Generated) {
        d.removeEventListener("focus", addPolyfill, true);
        d.removeEventListener("blur", addPolyfill, true);
        d.removeEventListener("focusin", removePolyfill, true);
        d.removeEventListener("focusout", removePolyfill, true);
      }
      setTimeout(function () {
        d.removeEventListener("focusin", removePolyfill, true);
        d.removeEventListener("focusout", removePolyfill, true);
      });
    }
  })();

  var contextPath = "http://localhost:9000";

  var myCarousel = function () {
    var carousel,
      slides,
      index,
      slidenav,
      settings,
      timer,
      setFocus,
      animationSuspended,
      announceItem,
      touchstartX = 0,
      touchendX = 0,
      touchstartY = 0,
      touchmoveX = 0,
      touchmoveY = 0,
      isSwipe = false,
      isScrolling;

    function forEachElement(elements, fn) {
      for (var i = 0; i < elements.length; i++) fn(elements[i], i);
    }

    function removeClass(el, className) {
      if (el.classList) {
        el.classList.remove(className);
      } else {
        el.className = el.className.replace(
          new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"),
          " "
        );
      }
    }

    function hasClass(el, className) {
      if (el.classList) {
        return el.classList.contains(className);
      } else {
        return new RegExp("(^| )" + className + "( |$)", "gi").test(el.className);
      }
    }

    // Swipe adelante o atrás
    function handleSwipeGesture() {
      if (isSwipe) {
        var deltaX = touchendX - touchstartX;
        if (deltaX < 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    }

    function init(set) {
      settings = set;
      carousel = document.getElementById(settings.id);
      slides = carousel.querySelectorAll(".slide");

      carousel.className = "carousel";

      slidenav = document.createElement("ul");
      slidenav.className = "slidenav";

      // Botón Previo
      var liPrev = document.createElement("li");
      liPrev.innerHTML =
        '<button type="button" class="btn-prev"><img src="/o/inssbt-portal-theme/images/ico-angle-circle-right.svg" alt="Noticia anterior"></button>';
      slidenav.appendChild(liPrev);
      liPrev.querySelector(".btn-prev").addEventListener("click", function () {
        prevSlide(true);
      });

      // Botón de Detener Animación
      if (settings.animate) {
        var liStop = document.createElement("li");
        liStop.innerHTML = settings.startAnimated
          ? '<button data-action="stop"><span class="visuallyhidden">Detener animación</span>&#xFFED;</button>'
          : '<button data-action="start"><span class="visuallyhidden">Iniciar animación </span>&#x25B6;</button>';
        //   slidenav.appendChild(liStop);
      }

      // Botones del Carrusel
      forEachElement(slides, function (el, i) {
        var li = document.createElement("li");
        var klass = i === 0 ? 'class="current" ' : "";
        var kurrent =
          i === 0 ? ' <span class="visuallyhidden">(Noticia actual)</span>' : "";

        li.innerHTML =
          "<button " +
          klass +
          'data-slide="' +
          i +
          '"><span class="visuallyhidden">Noticia ' +
          (i + 1) +
          kurrent +
          "</span></button>";
        slidenav.appendChild(li);
      });

      // Botón Siguiente
      var liNext = document.createElement("li");
      liNext.innerHTML =
        '<button type="button" class="btn-next"><img src="/o/inssbt-portal-theme/images/ico-angle-circle-right.svg" alt="Noticia siguiente"></button>';
      slidenav.appendChild(liNext);
      liNext.querySelector(".btn-next").addEventListener("click", function () {
        nextSlide(true);
      });

      slidenav.addEventListener(
        "click",
        function (event) {
          var button = event.target;
          if (button.localName == "button") {
            if (button.getAttribute("data-slide")) {
              stopAnimation();
              setSlides(button.getAttribute("data-slide"), true);
            } else if (button.getAttribute("data-action") == "stop") {
              stopAnimation();
            } else if (button.getAttribute("data-action") == "start") {
              startAnimation();
            }
          }
        },
        true
      );

      carousel.appendChild(slidenav);

      var liveregion = document.createElement("div");
      liveregion.setAttribute("aria-live", "polite");
      liveregion.setAttribute("aria-atomic", "true");
      liveregion.setAttribute("class", "liveregion visuallyhidden");
      carousel.appendChild(liveregion);

      slides[0].parentNode.addEventListener("transitionend", function (event) {
        var slide = event.target;
        removeClass(slide, "in-transition");
        if (hasClass(slide, "current")) {
          if (setFocus) {
            slide.setAttribute("tabindex", "-1");
            slide.focus();
            setFocus = false;
          }
        }
      });

      carousel.addEventListener("mouseenter", suspendAnimation);
      carousel.addEventListener("mouseleave", function (event) {
        if (animationSuspended) {
          startAnimation();
        }
      });

      carousel.addEventListener("focusin", function (event) {
        if (!hasClass(event.target, "slide")) {
          suspendAnimation();
        }
      });
      carousel.addEventListener("focusout", function (event) {
        if (!hasClass(event.target, "slide") && animationSuspended) {
          startAnimation();
        }
      });

      carousel.addEventListener(
        "touchstart",
        function (e) {
          touchstartX = e.changedTouches[0].screenX;
          touchstartY = e.changedTouches[0].screenY;
          isSwipe = false;
          isScrolling = undefined;
        },
        false
      );

      carousel.addEventListener(
        "touchend",
        function (e) {
          touchendX = e.changedTouches[0].screenX;
          if (!isScrolling && Math.abs(touchendX - touchstartX) > 75) {
            isSwipe = true;
            stopAnimation();
            handleSwipeGesture();
          }
        },
        false
      );

      carousel.addEventListener(
        "touchmove",
        function (e) {
          touchmoveX = e.changedTouches[0].screenX;
          touchmoveY = e.changedTouches[0].screenY;

          if (isScrolling === undefined) {
            isScrolling =
              Math.abs(touchmoveY - touchstartY) > Math.abs(touchmoveX - touchstartX);
          }

          if (!isScrolling) {
            e.preventDefault(); // Prevent scrolling when swiping left/right
          }
        },
        { passive: false }
      );

      index = 0;
      setSlides(index);

      if (settings.startAnimated) {
        timer = setTimeout(nextSlide, 5000);
      }
    }

    function setSlides(new_current, setFocusHere, transition, announceItemHere) {
      setFocus = typeof setFocusHere !== "undefined" ? setFocusHere : false;
      announceItem = typeof announceItemHere !== "undefined" ? announceItemHere : false;
      transition = typeof transition !== "undefined" ? transition : "none";

      new_current = parseFloat(new_current);

      var length = slides.length;
      var new_next = new_current + 1;
      var new_prev = new_current - 1;

      if (new_next === length) {
        new_next = 0;
      } else if (new_prev < 0) {
        new_prev = length - 1;
      }

      for (var i = slides.length - 1; i >= 0; i--) {
        slides[i].className = "slide";
      }

      slides[new_next].className =
        "next slide" + (transition == "next" ? " in-transition" : "");
      slides[new_next].setAttribute("aria-hidden", "true");

      slides[new_prev].className =
        "prev slide" + (transition == "prev" ? " in-transition" : "");
      slides[new_prev].setAttribute("aria-hidden", "true");

      slides[new_current].className = "current slide";
      slides[new_current].removeAttribute("aria-hidden");

      if (announceItem) {
        carousel.querySelector(".liveregion").textContent =
          "Fotografía " + (new_current + 1) + " de " + slides.length;
      }

      if (settings.slidenav) {
        var buttons = carousel.querySelectorAll(".slidenav button[data-slide]");
        for (var j = buttons.length - 1; j >= 0; j--) {
          buttons[j].className = "";
          buttons[j].innerHTML =
            '<span class="visuallyhidden">Noticia ' + (j + 1) + "</span>";
        }
        buttons[new_current].className = "current";
        buttons[new_current].innerHTML =
          '<span class="visuallyhidden">Noticia ' +
          (new_current + 1) +
          ' </span><span class="visuallyhidden">(Noticia actual)</span>';
      }

      index = new_current;
    }

    function nextSlide(announceItem) {
      announceItem = typeof announceItem !== "undefined" ? announceItem : false;

      var length = slides.length,
        new_current = index + 1;

      if (new_current === length) {
        new_current = 0;
      }

      setSlides(new_current, false, "prev", announceItem);

      if (settings.animate) {
        timer = setTimeout(nextSlide, 5000);
      }
    }

    function prevSlide(announceItem) {
      announceItem = typeof announceItem !== "undefined" ? announceItem : false;

      var length = slides.length,
        new_current = index - 1;

      if (new_current < 0) {
        new_current = length - 1;
      }

      setSlides(new_current, false, "next", announceItem);
    }

    function stopAnimation() {
      clearTimeout(timer);
      settings.animate = false;
      animationSuspended = false;
      var actionButton = carousel.querySelector("[data-action='start']");
      if (actionButton) {
        actionButton.innerHTML =
          '<span class="visuallyhidden">Iniciar animacion </span>&#x25B6;';
        actionButton.setAttribute("data-action", "start");
      }
    }

    function startAnimation() {
      settings.animate = true;
      animationSuspended = false;
      timer = setTimeout(nextSlide, 5000);
      var actionButton = carousel.querySelector("[data-action='stop']");
      if (actionButton) {
        actionButton.innerHTML =
          '<span class="visuallyhidden">Detener animacion </span>&#xFFED;';
        actionButton.setAttribute("data-action", "stop");
      }
    }

    function suspendAnimation() {
      if (settings.animate) {
        clearTimeout(timer);
        settings.animate = false;
        animationSuspended = true;
      }
    }

    return {
      init: init,
      next: nextSlide,
      prev: prevSlide,
      goto: setSlides,
      stop: stopAnimation,
      start: startAnimation,
    };
  };

  var c = new myCarousel();
  c.init({
    id: "c",
    slidenav: true,
    animate: true,
    startAnimated: true,
  });
  
}

// Scripts para el componente noticias-item-main

// Scripts para el componente noticias-otras

// Scripts para el componente testing

'use strict';

/**
 * Copyright Marc J. Schmidt. See the LICENSE file at the top-level
 * directory of this distribution and at
 * https://github.com/marcj/css-element-queries/blob/master/LICENSE.
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.ResizeSensor = factory();
    }
}(typeof window !== 'undefined' ? window : this, function () {

    // Make sure it does not throw in a SSR (Server Side Rendering) situation
    if (typeof window === 'undefined') {
        return null;
    }
    // https://github.com/Semantic-Org/Semantic-UI/issues/3855
    // https://github.com/marcj/css-element-queries/issues/257
    var globalWindow = typeof window != 'undefined' && window.Math == Math
        ? window
        : typeof self != 'undefined' && self.Math == Math
            ? self
            : Function('return this')();
    // Only used for the dirty checking, so the event callback count is limited to max 1 call per fps per sensor.
    // In combination with the event based resize sensor this saves cpu time, because the sensor is too fast and
    // would generate too many unnecessary events.
    var requestAnimationFrame = globalWindow.requestAnimationFrame ||
        globalWindow.mozRequestAnimationFrame ||
        globalWindow.webkitRequestAnimationFrame ||
        function (fn) {
            return globalWindow.setTimeout(fn, 20);
        };

    var cancelAnimationFrame = globalWindow.cancelAnimationFrame ||
        globalWindow.mozCancelAnimationFrame ||
        globalWindow.webkitCancelAnimationFrame ||
        function (timer) {
            globalWindow.clearTimeout(timer);
        };

    /**
     * Iterate over each of the provided element(s).
     *
     * @param {HTMLElement|HTMLElement[]} elements
     * @param {Function}                  callback
     */
    function forEachElement(elements, callback){
        var elementsType = Object.prototype.toString.call(elements);
        var isCollectionTyped = ('[object Array]' === elementsType
            || ('[object NodeList]' === elementsType)
            || ('[object HTMLCollection]' === elementsType)
            || ('[object Object]' === elementsType)
            || ('undefined' !== typeof jQuery && elements instanceof jQuery) //jquery
            || ('undefined' !== typeof Elements && elements instanceof Elements) //mootools
        );
        var i = 0, j = elements.length;
        if (isCollectionTyped) {
            for (; i < j; i++) {
                callback(elements[i]);
            }
        } else {
            callback(elements);
        }
    }

    /**
    * Get element size
    * @param {HTMLElement} element
    * @returns {Object} {width, height}
    */
    function getElementSize(element) {
        if (!element.getBoundingClientRect) {
            return {
                width: element.offsetWidth,
                height: element.offsetHeight
            }
        }

        var rect = element.getBoundingClientRect();
        return {
            width: Math.round(rect.width),
            height: Math.round(rect.height)
        }
    }

    /**
     * Apply CSS styles to element.
     *
     * @param {HTMLElement} element
     * @param {Object} style
     */
    function setStyle(element, style) {
        Object.keys(style).forEach(function(key) {
            element.style[key] = style[key];
        });
    }

    /**
     * Class for dimension change detection.
     *
     * @param {Element|Element[]|Elements|jQuery} element
     * @param {Function} callback
     *
     * @constructor
     */
    var ResizeSensor = function(element, callback) {
        //Is used when checking in reset() only for invisible elements
        var lastAnimationFrameForInvisibleCheck = 0;

        /**
         *
         * @constructor
         */
        function EventQueue() {
            var q = [];
            this.add = function(ev) {
                q.push(ev);
            };

            var i, j;
            this.call = function(sizeInfo) {
                for (i = 0, j = q.length; i < j; i++) {
                    q[i].call(this, sizeInfo);
                }
            };

            this.remove = function(ev) {
                var newQueue = [];
                for(i = 0, j = q.length; i < j; i++) {
                    if(q[i] !== ev) newQueue.push(q[i]);
                }
                q = newQueue;
            };

            this.length = function() {
                return q.length;
            }
        }

        /**
         *
         * @param {HTMLElement} element
         * @param {Function}    resized
         */
        function attachResizeEvent(element, resized) {
            if (!element) return;
            if (element.resizedAttached) {
                element.resizedAttached.add(resized);
                return;
            }

            element.resizedAttached = new EventQueue();
            element.resizedAttached.add(resized);

            element.resizeSensor = document.createElement('div');
            element.resizeSensor.dir = 'ltr';
            element.resizeSensor.className = 'resize-sensor';

            var style = {
                pointerEvents: 'none',
                position: 'absolute',
                left: '0px',
                top: '0px',
                right: '0px',
                bottom: '0px',
                overflow: 'hidden',
                zIndex: '-1',
                visibility: 'hidden',
                maxWidth: '100%'
            };
            var styleChild = {
                position: 'absolute',
                left: '0px',
                top: '0px',
                transition: '0s',
            };

            setStyle(element.resizeSensor, style);

            var expand = document.createElement('div');
            expand.className = 'resize-sensor-expand';
            setStyle(expand, style);

            var expandChild = document.createElement('div');
            setStyle(expandChild, styleChild);
            expand.appendChild(expandChild);

            var shrink = document.createElement('div');
            shrink.className = 'resize-sensor-shrink';
            setStyle(shrink, style);

            var shrinkChild = document.createElement('div');
            setStyle(shrinkChild, styleChild);
            setStyle(shrinkChild, { width: '200%', height: '200%' });
            shrink.appendChild(shrinkChild);

            element.resizeSensor.appendChild(expand);
            element.resizeSensor.appendChild(shrink);
            element.appendChild(element.resizeSensor);

            var computedStyle = window.getComputedStyle(element);
            var position = computedStyle ? computedStyle.getPropertyValue('position') : null;
            if ('absolute' !== position && 'relative' !== position && 'fixed' !== position && 'sticky' !== position) {
                element.style.position = 'relative';
            }

            var dirty = false;

            //last request animation frame id used in onscroll event
            var rafId = 0;
            var size = getElementSize(element);
            var lastWidth = 0;
            var lastHeight = 0;
            var initialHiddenCheck = true;
            lastAnimationFrameForInvisibleCheck = 0;

            var resetExpandShrink = function () {
                var width = element.offsetWidth;
                var height = element.offsetHeight;

                expandChild.style.width = (width + 10) + 'px';
                expandChild.style.height = (height + 10) + 'px';

                expand.scrollLeft = width + 10;
                expand.scrollTop = height + 10;

                shrink.scrollLeft = width + 10;
                shrink.scrollTop = height + 10;
            };

            var reset = function() {
                // Check if element is hidden
                if (initialHiddenCheck) {
                    var invisible = element.offsetWidth === 0 && element.offsetHeight === 0;
                    if (invisible) {
                        // Check in next frame
                        if (!lastAnimationFrameForInvisibleCheck){
                            lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function(){
                                lastAnimationFrameForInvisibleCheck = 0;
                                reset();
                            });
                        }

                        return;
                    } else {
                        // Stop checking
                        initialHiddenCheck = false;
                    }
                }

                resetExpandShrink();
            };
            element.resizeSensor.resetSensor = reset;

            var onResized = function() {
                rafId = 0;

                if (!dirty) return;

                lastWidth = size.width;
                lastHeight = size.height;

                if (element.resizedAttached) {
                    element.resizedAttached.call(size);
                }
            };

            var onScroll = function() {
                size = getElementSize(element);
                dirty = size.width !== lastWidth || size.height !== lastHeight;

                if (dirty && !rafId) {
                    rafId = requestAnimationFrame(onResized);
                }

                reset();
            };

            var addEvent = function(el, name, cb) {
                if (el.attachEvent) {
                    el.attachEvent('on' + name, cb);
                } else {
                    el.addEventListener(name, cb);
                }
            };

            addEvent(expand, 'scroll', onScroll);
            addEvent(shrink, 'scroll', onScroll);

            // Fix for custom Elements and invisible elements
            lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function(){
                lastAnimationFrameForInvisibleCheck = 0;
                reset();
            });
        }

        forEachElement(element, function(elem){
            attachResizeEvent(elem, callback);
        });

        this.detach = function(ev) {
            // clean up the unfinished animation frame to prevent a potential endless requestAnimationFrame of reset
            if (lastAnimationFrameForInvisibleCheck) {
                cancelAnimationFrame(lastAnimationFrameForInvisibleCheck);
                lastAnimationFrameForInvisibleCheck = 0;
            }
            ResizeSensor.detach(element, ev);
        };

        this.reset = function() {
            //To prevent invoking element.resizeSensor.resetSensor if it's undefined
            if (element.resizeSensor.resetSensor) {
                element.resizeSensor.resetSensor();
            }
        };
    };

    ResizeSensor.reset = function(element) {
        forEachElement(element, function(elem){
            //To prevent invoking element.resizeSensor.resetSensor if it's undefined
            if (element.resizeSensor.resetSensor) {
                elem.resizeSensor.resetSensor();
            }
        });
    };

    ResizeSensor.detach = function(element, ev) {
        forEachElement(element, function(elem){
            if (!elem) return;
            if(elem.resizedAttached && typeof ev === 'function'){
                elem.resizedAttached.remove(ev);
                if(elem.resizedAttached.length()) return;
            }
            if (elem.resizeSensor) {
                if (elem.contains(elem.resizeSensor)) {
                    elem.removeChild(elem.resizeSensor);
                }
                delete elem.resizeSensor;
                delete elem.resizedAttached;
            }
        });
    };

    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function (mutations) {
            for (var i in mutations) {
                if (mutations.hasOwnProperty(i)) {
                    var items = mutations[i].addedNodes;
                    for (var j = 0; j < items.length; j++) {
                        if (items[j].resizeSensor) {
                            ResizeSensor.reset(items[j]);
                        }
                    }
                }
            }
        });

        document.addEventListener('DOMContentLoaded', function (event) {
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    }

    return ResizeSensor;

}));